import * as angular from 'angular';

import { ComponentDefinition, ImportResult } from '../../../models';
import { IAlarmService, ILoggerService } from '../../../services';

class AlarmsImportController implements angular.IComponentController {
    fileList: FileList;
    importResult: ImportResult;
    isLoading: boolean;
    onRefresh: () => void;

    static $inject = [
        'alarmService',
        'loggerService'
    ];

    constructor(
        private _alarmService: IAlarmService,
        private _loggerService: ILoggerService
    ) {
    }

    upload(files: FileList) {
        if (files && files.length) {
            this.isLoading = true;
            this._alarmService
                .upload(files[0])
                .then(data => {
                    this.importResult = {
                        result: data.result,
                        createdCount: data.created.length,
                        updatedCount: data.updated.length,
                        failedCount: data.notUpdated.length
                    };
                    if (this.onRefresh) {
                        this.onRefresh();
                    }
                })
                .catch(reason => {
                    this._loggerService.logError(reason.data.Message);
                })
                .finally(() => {
                    this.isLoading = false;
                });
        }
    }
}

export const wtAlarmsImport: ComponentDefinition = {
    componentId: 'wtAlarmsImport',
    controller: AlarmsImportController,
    template: require('./alarmsImport.component.html'),
    controllerAs: 'vm',
    bindings: {
        onRefresh: '&?'
    }
};